import React, {MouseEvent, Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/footer"
import connect from "./connect"
import {RegionModel} from "../../models/footerModel"
import {TextModel} from "../../models/text"

type CopyrightProps = {
    region?: RegionModel
    siteUrl: string
    text: TextModel
    deviceSwitcherFn: (event: MouseEvent<HTMLAnchorElement>, url: string) => void
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const Copyright = memo((props: CopyrightProps) => {
    const TemplatedCopyright = useTemplatedComponent(props.templating, MANIFEST)
    return (
        <Suspense>
            <TemplatedCopyright {...props} />
        </Suspense>
    )
})

Copyright.displayName = "Copyright"

export default connect(Copyright)
